import { Formik, Form } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { newpassword } from "../redux/actions/auth/auth.actions";
import { Button, Col } from "reactstrap";
import * as Yup from "yup";
import { IoMdLock } from "react-icons/io";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useTranslation } from "react-i18next";

const NewPasswordComp = () => {
  const { t } = useTranslation();
  const resData = useSelector((state) => state?.auth?.forgotPassword?.user);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [errorMsg, setError] = useState("");
  console.log(errorMsg, "errorMsg")
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShown2, setPasswordShown2] = useState(false);
  // const active_token = { token: location.search.replace("?token=", "") };
  const validationSchema = Yup.object().shape({
    password: Yup.string("Please fill in the field Thank You").required(),
    confirmPassword: Yup.string().oneOf([Yup.ref("password")], "Passwords must match").required(),
  });
  const handleSubmit = (values) => {
    const resetData = {
      email: resData.email,
      password: values.password,
    };
    dispatch(newpassword(resetData)).then((res) => {
      console.log(res)
      if (res.state === "success") {
        navigate("/login")
        setError("")
      } else {
        setError("Enter valid Email")
      }
    });
  };
  // function clearError() {
  //   return (
  //     errorMsg?
  //   <div className="mt-4 error-text">{errorMsg}</div>:null
  // )}
  function signUpPageChange() {
    navigate("/")
    setError("")
  }
  return (
    <>
      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          errors,
          touched,
          isValid,
          dirty,
        }) => (
          <Form onSubmit={handleSubmit}>
            {/* <Col lg="12" md="12" sm="12" xs="12">
              {errorMsg !== null ? clearError() : ""}
              <div
                className=""
                onClick={() => {
                  setError("");
                }}
              >
                <div className="position-relative mb-3 mt-5 px-4">
                  <label className="Label">Email Address</label>
                  <MdEmail className="MdEmail" color="black" size={20} />
                  <input
                    className="form-control input-btn email"
                    name="email"
                    value={values.email}
                    type="email"
                    placeholder="Email Address"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </Col> */}
            <Col lg="12" md="12" sm="12" xs="12">
              <div className="mt-4 position-relative px-4">
                <label className="Label">{t('password')}</label>
                <IoMdLock className="IoMdLock" color="black" size={20} />
                <input
                  className="form-control input-btn pass"
                  name="password"
                  value={values.password}
                  type={passwordShown ? "text" : "password"}
                  placeholder="• • • • • • • •"
                  onChange={handleChange}
                />
                {passwordShown === true ?
                  <AiFillEye onClick={() => setPasswordShown(false)} className="eyeInvisible" color="black" size={20} /> :
                  <AiFillEyeInvisible onClick={() => setPasswordShown(true)} className="eyeInvisible" color="black" size={20} />
                }
              </div>
              {(errors.password) && (touched.password) ? (
                <div className="mt-4 text-align-center error-text">
                  {t('fillField')}
                </div>
              ) : null}

            </Col>
            <Col lg="12" md="12" sm="12" xs="12">
                <div className="mt-3 position-relative px-4">
                <label className="Label">{t('confirmPassword')}</label>
                <IoMdLock className="IoMdLock" color="black" size={20} />
                  <input
                    className="form-control input-btn pass"
                    value={values.confirmPassword}
                    name="confirmPassword"
                    type={passwordShown2 ? "text" : "password"}
                    placeholder="• • • • • • • •"
                    onChange={handleChange}
                  />
                  {passwordShown2 === true?
                   <AiFillEye onClick={() => setPasswordShown2(false)} className="eyeInvisible" color="black" size={20}/>:
                   <AiFillEyeInvisible onClick={() => setPasswordShown2(true)} className="eyeInvisible" color="black" size={20}/>
                  }
                </div>
                {(errors.confirmPassword) && (touched.confirmPassword) ? (
                  <div className="mt-4 text-align-center error-text">
                    {t('fillField')}
                  </div>
                ) : null}
              </Col>
            <div className="d-flex justify-content-end my-2">
              {/* <Label check className="RememberMe" style={{ marginTop: "10px", marginBottom: "10px" }}>
                <Input type="checkbox" id="checkbox2" className="checkbox" />
                Remember me
              </Label> */}
            </div>
            <Col lg="12" md="12" sm="12" xs="12" className="">
              <Button
                type="submit"
                className="submit-btn ib-btn w-100 mx-4"
                disabled={!(dirty && isValid)}
              >
                {t('createNewPassword')}
              </Button>
              <div className="d-flex justify-content-between align-items-center">
                <p className="dontHave">{t('alreadyAccount')}</p>
                <Button className="signup_button" onClick={signUpPageChange} ><b>{t('signIn')}</b></Button>
              </div>
            </Col>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NewPasswordComp;